import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppHomepage from './AppHomepage';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><AppHomepage /></React.StrictMode>);
